import { graphql } from "gql.tada";
import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";
import { TagFragment } from "@queries/fragments/TagFragment";

// get the minimul level of detail needed for showing links to other blog posts
export const GetBlogFeed = graphql(
  `
    query GetBlogFeed(
      $locale: String,
      $preview: Boolean
    ) {
      blogPostPageCollection(
        locale: $locale,
        preview: $preview
        #limit: 3
      ) {
        items {
          sys { id, firstPublishedAt }
          publicationDate
          updatedDate
          slug
          postTitle
          postSummary
          postTldr
          heroImage {
            ...AccessibleMediaFragment
          }
          tagsCollection(limit: 20) {
            items {
              ...TagFragment
            }
          }
        }
      }
    }
  `,
  [
    AccessibleMediaFragment,
    TagFragment,
  ]
);
